import { useQuery } from '@tanstack/react-query'
import { deviceBusinessAppsQuery } from '../api/businessApps'

/**
 * "Part of: Charisma ERP (Database), Opera PMS (Application server)" pe fila
 * Summary a aparatului - aplicatiile de business din care face parte.
 *
 * Fara aplicatii, fara drept de CMDB sau cu capatul cazut nu se deseneaza
 * nimic: fisa aparatului nu se strica din cauza asta.
 */
export function DevicePartOfApps({ id }: { id: number }) {
  const { data } = useQuery({ ...deviceBusinessAppsQuery(id), retry: false })
  const apps = data?.apps ?? []
  if (apps.length === 0) return null

  return (
    <div className="dv-fact dv-part-of">
      <span className="dv-k">Part of</span>
      <span className="dv-v">
        <i className="fas fa-cubes" aria-hidden="true"></i>{' '}
        {apps.map((a, i) => (
          <span key={`${a.id}-${a.role}`}>
            {i > 0 && ', '}
            <a href={`/app/applications/${a.id}`}>{a.name}</a> ({a.roleLabel})
          </span>
        ))}
      </span>
    </div>
  )
}
